// Mock data for D-H Gadiola Independent Contractor & Cable Specialist

export const companyInfo = {
  name: "D-H Gadiola",
  tagline: "Independent Contractor & Cable Specialist",
  email: "info@davieshaalandgadiolcc.com",
  address: "2845 Round Top Drive, Honolulu, HI 96822",
  whatsapp: "+1 586 926 3056",
  whatsappLink: "https://wa.me/+15869263056",
  yearsInBusiness: "25+",
  foundedYear: "1999",
  web3formsKey: "417a0977-bcc2-4b55-9e64-c7584ab21d1b",
};

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  {
    name: "Services",
    path: "/services",
    submenu: [
      { name: "Military Spec Products", path: "/services/military-spec" },
      { name: "Commercial Products", path: "/services/commercial" },
      { name: "Heat Shrinkable Products", path: "/services/heat-shrinkable" },
      { name: "Fiber Optic Products", path: "/services/fiber-optic" },
      { name: "Insulation & Conductor Types", path: "/services/insulation" },
    ],
  },
  { name: "Special Services", path: "/special-services" },
  { name: "Handbook & Reference", path: "/handbook" },
  { name: "Request Info", path: "/request-info" },
  { name: "Blog", path: "/blog" },
];

export const productCategories = [
  {
    id: 1,
    title: "Military Spec Products",
    description:
      "Mil-spec wires and cables engineered to meet exacting military and defense industry standards.",
    image: "https://images.unsplash.com/photo-1734956524110-5bbfba3c59b5",
    slug: "military-spec",
    longDescription:
      "Our military-grade wire and cable products meet rigorous defense industry specifications including MIL-W-22759, MIL-DTL-27500, and MIL-C-17. Used in aerospace, naval, and ground defense applications across the Pacific.",
    features: [
      "Compliant with MIL-W-22759, MIL-DTL-27500, MIL-C-17",
      "Tin-plated, silver-plated, and nickel-plated conductors",
      "PTFE, ETFE, and crosslinked insulations",
      "Shielded and jacketed assemblies for harsh environments",
      "Full traceability and documentation packages",
    ],
    applications: [
      "Aerospace platforms",
      "Naval vessels & submarines",
      "Defense electronics",
      "Ground vehicles",
      "Communication systems",
    ],
  },
  {
    id: 2,
    title: "Commercial Products",
    description:
      "A complete range of commercial electrical wire & cable for every job, large or small.",
    image: "https://images.unsplash.com/photo-1761507321319-2d59343016f6",
    slug: "commercial",
    longDescription:
      "From single-conductor hookup wire to multi-conductor control cables, our commercial line covers every common standard — UL, CSA, NEC and more — with on-island stock for fast project turnaround.",
    features: [
      "UL/CSA listed building & control wire",
      "THHN/THWN, MTW, TFFN, XHHW",
      "Multi-conductor control & instrumentation cable",
      "Portable cord (SOOW, SJOOW)",
      "Power & lighting cable assemblies",
    ],
    applications: [
      "Commercial buildings",
      "Industrial facilities",
      "Hospitality & retail",
      "Data centers",
      "Renewable energy installations",
    ],
  },
  {
    id: 3,
    title: "Heat Shrinkable Products",
    description:
      "Custom heat shrink shapes, tubing and protective sleeving for any specification.",
    image: "https://images.unsplash.com/photo-1625481302062-7a77e4000649",
    slug: "heat-shrinkable",
    longDescription:
      "Standard and custom heat-shrink solutions — from thin-wall polyolefin tubing to molded transitions, breakouts, and end caps. We help you select the right ratio, material, and adhesive for the job.",
    features: [
      "Thin-wall, medium-wall and heavy-wall tubing",
      "Polyolefin, fluoropolymer, elastomer and PVC",
      "2:1 through 6:1 shrink ratios",
      "Adhesive-lined moisture sealing",
      "Custom molded shapes & boots",
    ],
    applications: [
      "Cable insulation & repair",
      "Strain relief & boots",
      "Splicing & terminations",
      "Bundling & color-coding",
      "Environmental sealing",
    ],
  },
  {
    id: 4,
    title: "Fiber Optic Products",
    description:
      "High-bandwidth fiber optic cables for data, telecommunications and specialty installations.",
    image: "https://images.unsplash.com/photo-1773999088234-b7c26a681ff8",
    slug: "fiber-optic",
    longDescription:
      "Single-mode and multi-mode fiber, indoor/outdoor, armored, and tactical assemblies — engineered for reliable high-speed data, voice, and video across the toughest installations.",
    features: [
      "Single-mode (OS2) and multi-mode (OM3/OM4/OM5)",
      "Indoor riser, plenum and outdoor loose-tube",
      "Armored and tactical breakout cables",
      "Pre-terminated assemblies (LC, SC, ST, MTP/MPO)",
      "On-site termination & testing services",
    ],
    applications: [
      "Telecom backbones",
      "Data center interconnect",
      "Campus & metro networks",
      "Industrial Ethernet",
      "Broadcast & A/V",
    ],
  },
  {
    id: 5,
    title: "Insulation & Conductor Types",
    description:
      "A broad selection of insulations, conductor materials and value-added services.",
    image: "https://images.pexels.com/photos/28286031/pexels-photo-28286031.jpeg",
    slug: "insulation",
    longDescription:
      "We help you pick the right combination of conductor and insulation for your environment — chemical resistance, temperature range, flexibility, voltage rating and more.",
    features: [
      "Bare, tinned, silver and nickel conductors",
      "Stranded, solid, and high-flex Litz options",
      "PVC, PE, XLPE, PTFE, ETFE, FEP, silicone",
      "Shielded (foil, braid, combo)",
      "Custom jacketing and color-coding",
    ],
    applications: [
      "High-temperature environments",
      "Chemical & oil exposure",
      "High-flex robotic cabling",
      "Marine & subsea",
      "Medical & laboratory",
    ],
  },
  {
    id: 6,
    title: "Special Services",
    description:
      "Cut-to-length, striping, twisting, jacketing, kitting and full custom engineering services.",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c",
    slug: "special-services",
    longDescription:
      "Beyond stock product, our value-added services let you receive material exactly the way you need it — saving labor, reducing waste, and shortening your build time.",
    features: [
      "Precision cut-to-length & striping",
      "Twisted pair / twisted triple assembly",
      "Custom jacketing & re-jacketing",
      "Kitting & sub-assembly",
      "Engineering, design & prototyping",
    ],
    applications: [
      "OEM build-to-print",
      "Just-in-time inventory programs",
      "Field service kits",
      "Prototype & R&D builds",
      "Repair & refurbishment",
    ],
  },
];

export const partners = [
  { name: "Pacific Wire", short: "PW" },
  { name: "Aloha Cable Co.", short: "AC" },
  { name: "Island Conductors", short: "IC" },
  { name: "Honolulu Electric", short: "HE" },
  { name: "Heritage Wire", short: "HW" },
  { name: "Spec Wire Group", short: "SW" },
  { name: "Maritime Cable", short: "MC" },
  { name: "Pro Conductor", short: "PC" },
  { name: "Trident Wire", short: "TW" },
  { name: "Summit Cable", short: "SC" },
];

export const stats = [
  { value: "25+", label: "Years of Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "100%", label: "Licensed & Insured" },
  { value: "24/7", label: "Customer Support" },
];

export const testimonials = [
  {
    name: "Marcus Reilly",
    role: "Operations Manager, Aloha Builders",
    quote:
      "D-H Gadiola delivered on every promise. The level of expertise and attention to detail on our commercial wiring project was unmatched.",
  },
  {
    name: "Lina Park",
    role: "Project Lead, Pacific Defense Systems",
    quote:
      "Their mil-spec capabilities and turnaround time saved us weeks. A true specialist you can trust with critical infrastructure.",
  },
  {
    name: "Hiro Tanaka",
    role: "Facilities Director, Honolulu Tech Park",
    quote:
      "From custom heat-shrink to full fiber install, the work has been clean, on-spec, and on-schedule every single time.",
  },
];

export const teamValues = [
  {
    title: "Craftsmanship",
    description:
      "Every termination, every splice, every install is treated as a finished product worthy of our name.",
    icon: "Hammer",
  },
  {
    title: "Reliability",
    description:
      "On time, on spec, on budget — backed by 25 years of repeat clients across the Pacific.",
    icon: "ShieldCheck",
  },
  {
    title: "Innovation",
    description:
      "From custom heat-shrink shapes to fiber retrofits, we bring engineering rigor to every challenge.",
    icon: "Lightbulb",
  },
  {
    title: "Local Roots",
    description:
      "Family-owned in Honolulu and proud to serve Hawaii — our crews live and work where you do.",
    icon: "MapPin",
  },
];

export const milestones = [
  { year: "1999", title: "Founded in Honolulu", description: "D-H Gadiola opens its doors as an independent electrical contractor." },
  { year: "2006", title: "Mil-Spec Certification", description: "Achieves full compliance with leading military wire & cable specifications." },
  { year: "2013", title: "Custom Engineering Lab", description: "In-house design lab launched for custom cable assemblies and heat-shrink shapes." },
  { year: "2019", title: "Fiber Optic Division", description: "Expands services to include single-mode and multi-mode fiber installation across the Pacific." },
  { year: "2024", title: "500+ Projects", description: "Surpasses 500 completed projects with a 99% on-time delivery rate." },
];

export const specialServices = [
  { title: "Cut-to-Length", description: "Precision-cut wire and cable to your exact specifications, eliminating field waste.", icon: "Scissors" },
  { title: "Striping & Marking", description: "Color-stripe and ink-jet marking for circuit identification and traceability.", icon: "Palette" },
  { title: "Twisting & Bonding", description: "Twisted pair, triple, and quad assemblies; ribbon and bonded constructions.", icon: "GitBranch" },
  { title: "Custom Jacketing", description: "Re-jacket existing cable or apply specialty jackets for unique environments.", icon: "Layers" },
  { title: "Kitting & Assembly", description: "Receive complete project kits assembled, labeled and ready for the field.", icon: "Boxes" },
  { title: "Design & Engineering", description: "Application engineering, prototyping, and full build-to-print services.", icon: "PenTool" },
];

export const handbookSections = [
  {
    title: "Wire Gauge & Ampacity",
    description: "Reference for AWG sizes, conductor area, resistance and rated current capacity.",
    items: ["AWG to mm² conversion", "Ampacity ratings (NEC Table 310.16)", "Voltage drop calculations", "Bundle derating factors"],
  },
  {
    title: "Insulation Materials",
    description: "Select the right insulation for temperature, chemical and mechanical requirements.",
    items: ["PVC vs XLPE comparison", "PTFE and FEP characteristics", "Silicone & elastomer options", "Flame ratings (VW-1, FT4)"],
  },
  {
    title: "Mil-Spec Standards",
    description: "Quick reference to common military wire & cable specifications used in defense work.",
    items: ["MIL-W-22759 series", "MIL-DTL-27500", "MIL-C-17 coax", "QPL & qualification basics"],
  },
  {
    title: "Heat-Shrink Selection",
    description: "Choosing shrink ratio, material and adhesive for your application.",
    items: ["2:1 vs 3:1 vs 4:1 ratios", "Polyolefin vs fluoropolymer", "Adhesive-lined for sealing", "Operating temperature ranges"],
  },
  {
    title: "Fiber Optic Basics",
    description: "Single-mode vs multi-mode, connector types and testing fundamentals.",
    items: ["OS2, OM3, OM4, OM5 grades", "LC / SC / MTP connectors", "Insertion loss & return loss", "OTDR testing principles"],
  },
  {
    title: "Installation Best Practices",
    description: "Guidelines for pulling, supporting and terminating wire & cable in the field.",
    items: ["Bend radius minimums", "Pulling tension limits", "Strain relief requirements", "Termination & labeling standards"],
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "choosing-the-right-mil-spec-wire",
    title: "Choosing the Right Mil-Spec Wire for Your Project",
    excerpt: "A practical guide to picking between MIL-W-22759 variants and what each rating actually means in the field.",
    image: "https://images.unsplash.com/photo-1734956524110-5bbfba3c59b5",
    date: "May 14, 2025",
    author: "Davies Haaland",
    category: "Mil-Spec",
    readTime: "6 min read",
  },
  {
    id: 2,
    slug: "fiber-optic-vs-copper-data",
    title: "Fiber Optic vs Copper: When Each Wins for Data",
    excerpt: "We break down distance, bandwidth, noise immunity and total cost — and when to mix the two.",
    image: "https://images.unsplash.com/photo-1773999088234-b7c26a681ff8",
    date: "April 28, 2025",
    author: "D-H Gadiola Team",
    category: "Fiber Optic",
    readTime: "8 min read",
  },
  {
    id: 3,
    slug: "heat-shrink-application-tips",
    title: "5 Heat-Shrink Application Tips That Save Field Time",
    excerpt: "Simple tricks for cleaner shrinks, better sealing and fewer reworks — straight from our shop floor.",
    image: "https://images.unsplash.com/photo-1625481302062-7a77e4000649",
    date: "April 10, 2025",
    author: "D-H Gadiola Team",
    category: "Tips & Tricks",
    readTime: "4 min read",
  },
  {
    id: 4,
    slug: "marine-cable-pacific-environments",
    title: "Marine-Grade Cable for Pacific Environments",
    excerpt: "Salt, sun and humidity don't forgive shortcuts. Here's how we spec cable for boats, docks and coastal sites.",
    image: "https://images.pexels.com/photos/28286031/pexels-photo-28286031.jpeg",
    date: "March 22, 2025",
    author: "Davies Haaland",
    category: "Marine",
    readTime: "5 min read",
  },
  {
    id: 5,
    slug: "kitting-saves-build-time",
    title: "How Kitting Cut Our Customer's Build Time by 30%",
    excerpt: "A behind-the-scenes look at one OEM partnership and the kitting program that transformed their assembly line.",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c",
    date: "March 5, 2025",
    author: "D-H Gadiola Team",
    category: "Case Study",
    readTime: "7 min read",
  },
  {
    id: 6,
    slug: "ul-vs-csa-listings-explained",
    title: "UL vs CSA Listings, Plainly Explained",
    excerpt: "Confused by the alphabet soup of listings? We translate the most common ones into plain English.",
    image: "https://images.unsplash.com/photo-1761507321319-2d59343016f6",
    date: "February 18, 2025",
    author: "D-H Gadiola Team",
    category: "Reference",
    readTime: "5 min read",
  },
];
